import { Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useLightBoxStyles = makeStyles({
  root: {
    position: "fixed",
    left: 0,
    top: 0,
    right: 0,
    height: "100vh",
    zIndex: 1300,
    backgroundColor: "rgba(0,0,0,.9)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  closeRoot: {
    position: "absolute",
    top: "5%",
    right: "5%",
    cursor: "pointer",
    background: "#1a97f5",
    borderRadius: "50%",
    display: "flex",
    height: 35,
    width: 35,
    alignItems: "center",
    justifyContent: "center",
  },
  close: {
    fontSize: 30,
    "& path": {
      fill: "#fff",
    },
  },
  image: {
    maxHeight: "70vh",
    maxWidth: "60vw",
    objectFit: "contain",
  },
  // ─── Gallery variant ──────────────────────────────────────────────────
  galleryGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
    gap: 12,
    width: "90vw",
    maxWidth: 1100,
    maxHeight: "82vh",
    overflowY: "auto",
    padding: 8,
  },
  galleryItem: {
    position: "relative",
    aspectRatio: "1 / 1",
    borderRadius: 8,
    overflow: "hidden",
    backgroundColor: "rgba(255,255,255,.06)",
    cursor: "pointer",
  },
  galleryImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    display: "block",
    transition: "transform .2s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
});
